module.exports = __webpack_public_path__ + "img/pdf-inactive.2d3722ae.png";